var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMagnify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/ Magnify") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/-Magnify",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(10.000000, 10.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.3437501,72.8437501 L58.9375001,54.4375001 C63.5000001,48.8750001 66.2500001,41.7500001 66.2500001,33.984375 C66.2500001,16.171875 51.7968751,1.71875 33.984375,1.71875 C16.15625,1.71875 1.71875,16.171875 1.71875,33.984375 C1.71875,51.7968751 16.15625,66.2500001 33.984375,66.2500001 C41.7500001,66.2500001 48.8593751,63.5156251 54.4218751,58.9531251 L72.8281251,77.3437501 C74.0781251,78.5937501 76.0937501,78.5937501 77.3437501,77.3437501 C78.5937501,76.1093751 78.5937501,74.0781251 77.3437501,72.8437501 Z M33.984375,59.8281251 C19.71875,59.8281251 8.12500001,48.2343751 8.12500001,33.984375 C8.12500001,19.734375 19.71875,8.12500001 33.984375,8.12500001 C48.2343751,8.12500001 59.8437501,19.734375 59.8437501,33.984375 C59.8437501,48.2343751 48.2343751,59.8281251 33.984375,59.8281251 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnify);
export default __webpack_public_path__ + "static/media/magnify.f40a179f1a75c241574853f79bacee19.svg";
export { ForwardRef as ReactComponent };